export var GroupDataTypes;
(function (GroupDataTypes) {
    GroupDataTypes[GroupDataTypes["Number"] = 0] = "Number";
    GroupDataTypes[GroupDataTypes["Bool"] = 1] = "Bool";
    GroupDataTypes[GroupDataTypes["Range"] = 10] = "Range";
    GroupDataTypes[GroupDataTypes["Age"] = 11] = "Age";
    GroupDataTypes[GroupDataTypes["StringExact"] = 20] = "StringExact";
    GroupDataTypes[GroupDataTypes["StringStartsWith"] = 21] = "StringStartsWith";
    GroupDataTypes[GroupDataTypes["StringEndsWith"] = 22] = "StringEndsWith";
    GroupDataTypes[GroupDataTypes["StringContains"] = 23] = "StringContains";
    GroupDataTypes[GroupDataTypes["ArrayIncludes"] = 30] = "ArrayIncludes";
})(GroupDataTypes || (GroupDataTypes = {}));
//# sourceMappingURL=groupDataType.enum.js.map